const includes = require('lodash/includes');

function removeClass(element, classToFind) {
  if (!element) {
    return undefined;
  }

  const classes = element.className.split(' ');

  return includes(classes, classToFind);
}

module.exports = removeClass;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/dom/has-class.js